import { BulkUpdateUsageConditions, mapBulkUpdateUsageConditionsToApi } from '../bulkUpdateUsageConditions';
import { cartConfig } from '../../config';
import { invalidateCartAggregations } from '../../shop/cart/useCartAggregations';
import { invalidateCartSummaryQuery } from './useCartSummaryQuery';
import { invalidateCartGroupedItems } from './useCartGroupedItems';
import { invalidateShoppingCartProducts } from './useShoppingCartProducts';
import { log } from '../../shared/utils/log';
import { http } from '../axios';
import { globalErrorResponse, isErrorOfType } from '../../shared/notification/actions';

export function useBulkUpdateUsageConditions() {
    return async (updates: BulkUpdateUsageConditions) => {
        const jsonBody = mapBulkUpdateUsageConditionsToApi(updates);

        try {
            await http.put(cartConfig().bulkUpdateUsageConditions, jsonBody);

            invalidateCartAggregations().then();
            invalidateCartSummaryQuery().then();
            invalidateCartGroupedItems().then();
            invalidateShoppingCartProducts().then();
        } catch (error) {
            log.error(error, { causedBy: 'products/actions -> bulkUpdateUsageConditionsInCart' });

            if (isErrorOfType(error)) {
                globalErrorResponse(error);
            }
        }
    };
}
